<div class="condition-card">
  <div class="condition-card-title">
    <h5 style="margin-top: 0px">{{ "freeGift.condition" | translate }}</h5>
    <div class="condition-buttons">
      <button
        class="btn button-ghost"
        style="margin-right: 16px"
        (click)="editCondition()"
      >
        <clr-icon shape="plus" dir="right"></clr-icon>
        {{ "common.edit" | translate }}
      </button>
      <button class="btn button-ghost" (click)="delete(condition.id)">
        <clr-icon shape="trash"></clr-icon>
        {{ "common.delete" | translate }}
      </button>
    </div>
  </div>

  <div class="condition-title-line"></div>

  <div class="condition-detail-line">
    <div>{{ "common.minQuantity" | translate }}:</div>
    <div style="margin-left: 6px">{{ condition.minQuantity }}</div>
  </div>

  <div class="condition-detail-line">
    <div>{{ "common.giftQuantity" | translate }}:</div>
    <div style="margin-left: 6px">{{ condition.giftQuantity }}</div>
  </div>
  <div class="condition-detail-line">
    <div>{{ "freeGift.gifts" | translate }}:</div>
  </div>

  <ng-container *ngFor="let gift of condition.productVariants">
    <div
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 6px;
        padding-left: 16px;
        margin-top: 6px;
      "
    >
      <img
        *ngIf="gift.product.featuredAsset; else imagePlaceholder"
        [src]="gift.product.featuredAsset?.preview"
        style="width: 100px; height: 100px; margin-right: 1rem"
      />

      <ng-template #imagePlaceholder>
        <div
          style="display: inline-block; margin-right: 1rem"
          class="placeholder"
        >
          <clr-icon shape="image" size="100"></clr-icon>
        </div>
      </ng-template>
      <div style="flex: 1; display: flex; flex-direction: column">
        <div
          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
        >
          {{ gift.name }}
        </div>
        <div>{{gift.sku}}</div>
        <div>{{ "common.stock" | translate }}: {{ decodeStock(gift.stockLevel) }}</div>
      </div>
    </div>
  </ng-container>
</div>
